import { Fragment, useState } from "react";

import "./preview.scss";

function Preview(props) {
  const [desktopImage, setDesktopImage] = useState(
    `/images/screens/${props.id}/desktop.png`
  );
  const [mobileImage, setMobileImage] = useState(
    `/images/screens/${props.id}/desktop.png`
  );

  const handleError = () => {
    setDesktopImage(null);
  };

  const handleMobileError = () => {
    setMobileImage(null);
  };

  return (
    <Fragment>
      <div className="preview__wrapper">
        <div className="preview__screen-wrapper">
          {desktopImage && (
            <img
              className="preview__screen"
              src={desktopImage}
              alt={`${props.title} website desktop preview`}
              loading="lazy"
              onError={handleError}
            />
          )}
          <div
            className={`preview__logo-overlay${
              desktopImage ? "" : " preview__logo-overlay--noHiding"
            }`}
          >
            <img
              className="preview__logo"
              src={`/images/clients/${props.id}.png`}
              alt={`${props.title} logo`}
              loading="lazy"
            />
          </div>
        </div>

        <img
          className="preview__image"
          src="/images/macbook.png"
          alt="imac device overlay"
          loading="lazy"
        />

        {mobileImage && (
          <div className="preview__phone">
            <div className="preview__phone-screen-wrapper">
              <img
                className="preview__phone-screen"
                src={`/images/screens/${props.id}/mobile.png`}
                alt={`${props.title} website mobile preview`}
                loading="lazy"
                onError={handleMobileError}
              />
            </div>

            <img
              className="preview__phone-image"
              src="/images/iphone.png"
              alt="iphone device overlay"
              loading="lazy"
            />
          </div>
        )}
      </div>

      {props.title && <div className="preview__info">{props.title}</div>}
      {props.client && <div className="preview__agency">{props.client}</div>}
    </Fragment>
  );
}

export default Preview;
